import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { FeederService } from 'src/app/services/feeder.service';

@Component({
  selector: 'app-add-update-feeder',
  templateUrl: './add-update-feeder.component.html',
  styleUrls: ['./add-update-feeder.component.scss']
})
export class AddUpdateFeederComponent implements OnInit {


  descriptionForm: FormGroup
  parameters: FormGroup
  alertParameter: FormGroup
  altertNotification: FormGroup
  dtmuDevice: FormGroup
  formData:any= {};
  deviceMaster: any;
  frequencyMsg: any = {};
  frequencyError: any;
  action: string;
  Frequency = ['Minutes','Days','Hours'];
  kv = ['11', '22', '33'];
  feederData: any;
  currentUserData = JSON.parse(localStorage.getItem('userData'))
  roleID = this.currentUserData.roleid;
  constructor(private formBuilder: FormBuilder, public dialogRef: MatDialogRef<AddUpdateFeederComponent>,  @Inject(MAT_DIALOG_DATA) public data: any, private toastr: ToastrService, private feederService: FeederService) { }

  ngOnInit() {
    this.deviceMaster = this.data.deviceMaster;
    this.action = this.data.action.toLowerCase();
    if(this.action.toLowerCase() == 'update'){
      this.feederData = this.data.feederData;
    }
    this.createForm();
  }

  createForm(){
    this.descriptionForm = this.formBuilder.group({
      'makeBy': [null, [Validators.required]],
      'serialNo': [null, [Validators.required]],
      'manufacturingDate': [null, [Validators.required]],
      'installationDate': [null, [Validators.required]],
      'rating': '',
      'kv': '',
    });

    this.parameters = this.formBuilder.group({
      'lug_temp': [true],
      'ambient_temp': [false],
      'humidity': [true],
      'loadPercentage': [true],
      'R_Ph_N': [true],
      'Y_Ph_N': [true],
      'B_Ph_N': [true],
      'RY_Voltage': [true],
      'YB_Voltage': [true],
      'BR_Voltage': [true],
      'L1': [true],
      'L2': [true],
      'L3': [true],
      'LN': [true],
      'I1': [true],
      'I2': [false],
      'I3': [false],
      'R1': [true],
      'R2': [false],
      'R3': [true],
      'R_Power_Factor': [true],
      'Y_Power_Factor': [true],
      'B_Power_Factor': [true],
      'Avg_Power_Factor': [true],
      'R_Active_Power': [true],
      'Y_Active_Power': [true],
      'B_Active_Power': [true],
      'Phase_Active_Power': [false],
      'R_Reactive_Power': [true],
      'Y_Reactive_Power': [false],
      'B_Reactive_Power': [true],
      'Phase_Reactive_Power': [false],
      'R_Apparent_Power': [true],
      'Y_Apparent_Power': [true],
      'B_Apparent_Power': [true],
      'Phase_Apparent_Power': [false],
      'Frequency': [true],
      'Device_Temp': [true],
      'VR_THD': [true],
      'VY_THD': [true],
      'VB_THD': [false],
      'IR_THD': [true],
      'IY_THD': [false],
      'IB_THD': [true],
      'RP_THD': [false],
      'YP_THD': [true],
      'BP_THD': [true],
      'System_Kwh': [true],
      'System_KvAh': [true]
    });

    this.alertParameter = this.formBuilder.group({
      'overLoad': [0],
      'overLoadEmail': [false],
      'overLoadSMS': [false],
      'overLoadFrequency': [1],
      'overLoadTime': 'Minutes',
      'underLoad': [0],
      'underLoadEmail': [false],
      'underLoadSMS': [false],
      'underLoadFrequency': [1],
      'underLoadTime': 'Minutes',
      'criticalLoad': [0],
      'criticalLoadEmail': [false],
      'criticalLoadSMS': [false],
      'criticalLoadFrequency': [1],
      'criticalLoadTime': 'Minutes',
      'highVoltage': [0],
      'highVoltageEmail': [false],
      'highVoltageSMS': [false],
      'highVoltageFrequency': [1],
      'highVoltageTime': 'Minutes',
      'lowVoltage': [0],
      'lowVoltageEmail': [false],
      'lowVoltageSMS': [false],
      'lowVoltageFrequency': [1],
      'lowVoltageTime': 'Minutes',
      'vUnbalance': [0],
      'vUnbalanceEmail': [false],
      'vUnbalanceSMS': [false],
      'vUnbalanceFrequency': [1],
      'vUnbalanceTime': 'Minutes',
      'iUnbalance': [0],
      'iUnbalanceEmail': [false],
      'iUnbalanceSMS': [false],
      'iUnbalanceFrequency': [1],
      'iUnbalanceTime': 'Minutes',
      'lugTemp': [0],
      'lugTempEmail': [false],
      'lugTempSMS': [false],
      'lugTempFrequency': [1],
      'lugTempTime': 'Minutes',
    });

    this.altertNotification = this.formBuilder.group({
      'email1':[null, [Validators.required, Validators.email]],
      'email2': [null, [Validators.email]],
      'email3': [null, [Validators.email]],
      'email4': [null, [Validators.email]],
      'email5': [null, [Validators.email]],
      'phoneNo1': [null, [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      'phoneNo2': [null, [Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      'phoneNo3': [null, [Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      'phoneNo4': [null, [Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      'phoneNo5': [null, [Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]]
    });

    this.dtmuDevice = this.formBuilder.group({
      'deviceCategory':[this.deviceMaster.deviceCategory, [Validators.required]],
      'deviceModel':[this.deviceMaster.deviceModel, [Validators.required]],
      'deviceId': [this.deviceMaster.deviceId, [Validators.required]],
      'heartBeat': ['', [Validators.required]],
      'name': ['', [Validators.required]],
      'passcode': ['', [Validators.required]],
      'remoteController': false,
      'onOffNotify':false,
      'onOffFlag': false,
    });

    if(this.action.toLowerCase() == 'update'){
      this.descriptionForm.controls['makeBy'].setValue(this.feederData['description'][0].makeBy);
      this.descriptionForm.controls['serialNo'].setValue(this.feederData['description'][0].serialNo);
      this.descriptionForm.controls['manufacturingDate'].setValue(this.feederData['description'][0].manufacturingDate);
      this.descriptionForm.controls['installationDate'].setValue(this.feederData['description'][0].installationDate);
      this.descriptionForm.controls['rating'].setValue(this.feederData['description'][0].rating);
      this.descriptionForm.controls['kv'].setValue(this.feederData['description'][0].kv)

      this.dtmuDevice.controls['deviceCategory'].setValue(this.feederData['description'][0].deviceCategory);
      this.dtmuDevice.controls['deviceModel'].setValue(this.feederData['description'][0].deviceModel);
      this.dtmuDevice.controls['deviceId'].setValue(this.feederData['description'][0].deviceID);
      this.dtmuDevice.controls['heartBeat'].setValue(this.feederData['description'][0].heartBeat);
      this.dtmuDevice.controls['name'].setValue(this.feederData['description'][0].name);
      this.dtmuDevice.controls['passcode'].setValue(this.feederData['description'][0].passcode);
      this.dtmuDevice.controls['remoteController'].setValue(this.feederData['description'][0].remoteController);
      this.dtmuDevice.controls['onOffNotify'].setValue(this.feederData['description'][0].onOffNotify);
      this.dtmuDevice.controls['onOffFlag'].setValue(this.feederData['description'][0].onOffFlag);

      this.parameters.controls['lug_temp'].setValue(this.feederData['parameterConfig'][0].lug_Temp=='1'? true: false);
      this.parameters.controls['humidity'].setValue(this.feederData['parameterConfig'][0].humidity=='1'? true: false);
      this.parameters.controls['ambient_temp'].setValue(this.feederData['parameterConfig'][0].ambient_Temp=='1'? true: false);
      this.parameters.controls['loadPercentage'].setValue(this.feederData['parameterConfig'][0].loadPercentage=='1'? true: false);
      this.parameters.controls['R_Ph_N'].setValue(this.feederData['parameterConfig'][0].R_Ph_N =='1'? true: false);
      this.parameters.controls['Y_Ph_N'].setValue(this.feederData['parameterConfig'][0].Y_Ph_N=='1'? true: false);
      this.parameters.controls['B_Ph_N'].setValue(this.feederData['parameterConfig'][0].B_Ph_N=='1'? true: false);
      this.parameters.controls['RY_Voltage'].setValue(this.feederData['parameterConfig'][0].RY_Voltage=='1'? true: false);
      this.parameters.controls['YB_Voltage'].setValue(this.feederData['parameterConfig'][0].YB_Voltage=='1'? true: false);
      this.parameters.controls['BR_Voltage'].setValue(this.feederData['parameterConfig'][0].BR_Voltage=='1'? true: false);
      this.parameters.controls['L1'].setValue(this.feederData['parameterConfig'][0].L1=='1'? true: false);
      this.parameters.controls['L2'].setValue(this.feederData['parameterConfig'][0].L2=='1'? true: false);
      this.parameters.controls['L3'].setValue(this.feederData['parameterConfig'][0].L3=='1'? true: false);
      this.parameters.controls['LN'].setValue(this.feederData['parameterConfig'][0].LN =='1'? true: false);
      this.parameters.controls['I1'].setValue(this.feederData['parameterConfig'][0].I1=='1'? true: false);
      this.parameters.controls['I2'].setValue(this.feederData['parameterConfig'][0].I2=='1'? true: false);
      this.parameters.controls['I3'].setValue(this.feederData['parameterConfig'][0].I3=='1'? true: false);
      this.parameters.controls['R1'].setValue(this.feederData['parameterConfig'][0].R1=='1'? true: false);
      this.parameters.controls['R2'].setValue(this.feederData['parameterConfig'][0].R2=='1'? true: false);
      this.parameters.controls['R3'].setValue(this.feederData['parameterConfig'][0].R3=='1'? true: false);
      this.parameters.controls['R_Power_Factor'].setValue(this.feederData['parameterConfig'][0].R_Power_Factor=='1'? true: false);
      this.parameters.controls['Y_Power_Factor'].setValue(this.feederData['parameterConfig'][0].Y_Power_Factor=='1'? true: false);
      this.parameters.controls['B_Power_Factor'].setValue(this.feederData['parameterConfig'][0].B_Power_Factor =='1'? true: false);
      this.parameters.controls['Avg_Power_Factor'].setValue(this.feederData['parameterConfig'][0].Avg_Power_Factor=='1'? true: false);
      this.parameters.controls['R_Active_Power'].setValue(this.feederData['parameterConfig'][0].R_Active_Power=='1'? true: false);
      this.parameters.controls['Y_Active_Power'].setValue(this.feederData['parameterConfig'][0].Y_Active_Power=='1'? true: false);
      this.parameters.controls['B_Active_Power'].setValue(this.feederData['parameterConfig'][0].B_Active_Power=='1'? true: false);
      this.parameters.controls['Phase_Active_Power'].setValue(this.feederData['parameterConfig'][0].Phase_Active_Power=='1'? true: false);
      this.parameters.controls['R_Reactive_Power'].setValue(this.feederData['parameterConfig'][0].R_Reactive_Power=='1'? true: false);
      this.parameters.controls['Y_Reactive_Power'].setValue(this.feederData['parameterConfig'][0].Y_Reactive_Power=='1'? true: false);
      this.parameters.controls['B_Reactive_Power'].setValue(this.feederData['parameterConfig'][0].B_Reactive_Power=='1'? true: false);
      this.parameters.controls['Phase_Reactive_Power'].setValue(this.feederData['parameterConfig'][0].Phase_Reactive_Power =='1'? true: false);
      this.parameters.controls['R_Apparent_Power'].setValue(this.feederData['parameterConfig'][0].R_Apparent_Power=='1'? true: false);
      this.parameters.controls['Y_Apparent_Power'].setValue(this.feederData['parameterConfig'][0].Y_Apparent_Power=='1'? true: false);
      this.parameters.controls['B_Apparent_Power'].setValue(this.feederData['parameterConfig'][0].B_Apparent_Power=='1'? true: false);
      this.parameters.controls['Phase_Apparent_Power'].setValue(this.feederData['parameterConfig'][0].Phase_Apparent_Power=='1'? true: false);
      this.parameters.controls['Frequency'].setValue(this.feederData['parameterConfig'][0].Frequency=='1'? true: false);
      this.parameters.controls['Device_Temp'].setValue(this.feederData['parameterConfig'][0].Device_Temp =='1'? true: false);
      this.parameters.controls['VR_THD'].setValue(this.feederData['parameterConfig'][0].VR_THD=='1'? true: false);
      this.parameters.controls['VY_THD'].setValue(this.feederData['parameterConfig'][0].VY_THD=='1'? true: false);
      this.parameters.controls['VB_THD'].setValue(this.feederData['parameterConfig'][0].VB_THD=='1'? true: false);
      this.parameters.controls['IR_THD'].setValue(this.feederData['parameterConfig'][0].IR_THD=='1'? true: false);
      this.parameters.controls['IY_THD'].setValue(this.feederData['parameterConfig'][0].IY_THD=='1'? true: false);
      this.parameters.controls['IB_THD'].setValue(this.feederData['parameterConfig'][0].IB_THD =='1'? true: false);
      this.parameters.controls['RP_THD'].setValue(this.feederData['parameterConfig'][0].RP_THD=='1'? true: false);
      this.parameters.controls['YP_THD'].setValue(this.feederData['parameterConfig'][0].YP_THD=='1'? true: false);
      this.parameters.controls['BP_THD'].setValue(this.feederData['parameterConfig'][0].BP_THD=='1'? true: false);
      this.parameters.controls['System_Kwh'].setValue(this.feederData['parameterConfig'][0].System_Kwh=='1'? true: false);
      this.parameters.controls['System_KvAh'].setValue(this.feederData['parameterConfig'][0].System_KvAh=='1'? true: false);

      this.alertParameter.setValue({
        overLoad:this.feederData['alertParameters'][0].parameterValue,
        overLoadEmail:this.feederData['alertParameters'][0].email=='1'? true: false,
        overLoadSMS:this.feederData['alertParameters'][0].sms=='1'? true: false,
        overLoadFrequency:this.feederData['alertParameters'][0].frequency,
        overLoadTime:this.feederData['alertParameters'][0].timeValue,
        underLoad: this.feederData['alertParameters'][1].parameterValue,
        underLoadEmail: this.feederData['alertParameters'][1].email=='1'? true: false,
        underLoadSMS: this.feederData['alertParameters'][1].sms=='1'? true: false,
        underLoadFrequency: this.feederData['alertParameters'][1].frequency,
        underLoadTime: this.feederData['alertParameters'][1].timeValue,
        criticalLoad: this.feederData['alertParameters'][2].parameterValue,
        criticalLoadEmail: this.feederData['alertParameters'][2].email=='1'? true: false,
        criticalLoadSMS: this.feederData['alertParameters'][2].sms=='1'? true: false,
        criticalLoadFrequency: this.feederData['alertParameters'][2].frequency,
        criticalLoadTime: this.feederData['alertParameters'][2].timeValue,
        
        highVoltage: this.feederData['alertParameters'][3].parameterValue,
        highVoltageEmail: this.feederData['alertParameters'][3].email=='1'? true: false,
        highVoltageSMS: this.feederData['alertParameters'][3].sms=='1'? true: false,
        highVoltageFrequency: this.feederData['alertParameters'][3].frequency,
        highVoltageTime: this.feederData['alertParameters'][3].timeValue,
        lowVoltage: this.feederData['alertParameters'][4].parameterValue,
        lowVoltageEmail: this.feederData['alertParameters'][4].email=='1'? true: false,
        lowVoltageSMS: this.feederData['alertParameters'][4].sms=='1'? true: false,
        lowVoltageFrequency: this.feederData['alertParameters'][4].frequency,
        lowVoltageTime: this.feederData['alertParameters'][4].timeValue,
        vUnbalance: this.feederData['alertParameters'][5].parameterValue,
        vUnbalanceEmail: this.feederData['alertParameters'][5].email=='1'? true: false,
        vUnbalanceSMS: this.feederData['alertParameters'][5].sms=='1'? true: false,
        vUnbalanceFrequency: this.feederData['alertParameters'][5].frequency,
        vUnbalanceTime: this.feederData['alertParameters'][5].timeValue,
        iUnbalance: this.feederData['alertParameters'][6].parameterValue,
        iUnbalanceEmail: this.feederData['alertParameters'][6].email=='1'? true: false,
        iUnbalanceSMS: this.feederData['alertParameters'][6].sms=='1'? true: false,
        iUnbalanceFrequency: this.feederData['alertParameters'][6].frequency,
        iUnbalanceTime: this.feederData['alertParameters'][6].timeValue,
        lugTemp: this.feederData['alertParameters'][7].parameterValue,
        lugTempEmail: this.feederData['alertParameters'][7].email=='1'? true: false,
        lugTempSMS: this.feederData['alertParameters'][7].sms=='1'? true: false,
        lugTempFrequency: this.feederData['alertParameters'][7].frequency,
        lugTempTime: this.feederData['alertParameters'][7].timeValue,
      });

      this.altertNotification.controls['email1'].setValue(this.feederData['alertNotifications'][0].email1);
      this.altertNotification.controls['email2'].setValue(this.feederData['alertNotifications'][0].email2);
      this.altertNotification.controls['email3'].setValue(this.feederData['alertNotifications'][0].email3);
      this.altertNotification.controls['email4'].setValue(this.feederData['alertNotifications'][0].email4);
      this.altertNotification.controls['email5'].setValue(this.feederData['alertNotifications'][0].email5);

      this.altertNotification.controls['phoneNo1'].setValue(this.feederData['alertNotifications'][0].phoneNo1);
      this.altertNotification.controls['phoneNo2'].setValue(this.feederData['alertNotifications'][0].phoneNo2);
      this.altertNotification.controls['phoneNo3'].setValue(this.feederData['alertNotifications'][0].phoneNo3);
      this.altertNotification.controls['phoneNo4'].setValue(this.feederData['alertNotifications'][0].phoneNo4);
      this.altertNotification.controls['phoneNo5'].setValue(this.feederData['alertNotifications'][0].phoneNo5);

    }
  }

  checkFrequency(event:any, frequency, time) {
    console.log("CHECK FREQUENCY:", event.target.value, frequency, time);
    console.log(this.alertParameter);
    console.log(this.alertParameter.value[time]);
    if(this.alertParameter.value[time] === 'Minutes') {
      if(event.target.value >  1440  || event.target.value < 1) {
       // this.alertParameter.controls.frequency.setValidators([Validators.minLength(1), Validators.maxLength(31)]);
        this.frequencyMsg[frequency] = 'Frequency value should be between 1-1440';
        this.frequencyError = 'There are Errors in Alert Parameters Form'
      } else {
        this.frequencyMsg[frequency] = '';
        this.frequencyError = ''
      }
    } else if(this.alertParameter.value[time] === 'Hours') {
      if(event.target.value >  11  || event.target.value < 1) {
       // this.alertParameter.controls.frequency.setValidators([Validators.minLength(1), Validators.maxLength(31)]);
        this.frequencyMsg[frequency] = 'Frequency value should be between 1-11';
        this.frequencyError = 'There are Errors in Alert Parameters Form'
      } else {
        this.frequencyMsg[frequency] = '';
        this.frequencyError = ''
      }
    } else if(this.alertParameter.value[time] === 'Minutes') {
      if(event.target.value >  59  || event.target.value < 1) {
       // this.alertParameter.controls.frequency.setValidators([Validators.minLength(1), Validators.maxLength(31)]);
        this.frequencyMsg[frequency] = 'Frequency value should be between 1-59';
        this.frequencyError = 'There are Errors in Alert Parameters Form'
      } else {
        this.frequencyMsg[frequency] = '';
        this.frequencyError = ''
      }
    }
  }

  close(response) {
    this.dialogRef.close();
    this.dialogRef.afterClosed().subscribe(value => {
      console.log(`Dialog sent:`, response);
    });
  }

  onSubmit(descriptionValues, parametersValues, alertParametersValues, altertNotificationValues, dtmuDeviceValues){
    descriptionValues.deletedFlag = 'A';
    descriptionValues.createdBy = JSON.parse(localStorage.getItem('userData')).userid;
    var today = new Date();
    var date='';
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    date = yyyy + '-' + mm + '-' + dd;
    descriptionValues.createdDate = Date.now().toString();
    var id= {'id': descriptionValues.serialNo};
    var metaData = {'createdBy':JSON.parse(localStorage.getItem('userData')).userid, 'createdDate':date};
    this.formData.action = this.action;

    if(this.action.toLowerCase() == 'update'){
      this.formData.serialNo = descriptionValues.serialNo;
      descriptionValues.manufacturingDate = typeof(descriptionValues.manufacturingDate) === 'object' ? moment(descriptionValues.manufacturingDate).format('YYYY-MM-DD') : descriptionValues.manufacturingDate.substr(0,10);
      descriptionValues.installationDate = typeof(descriptionValues.installationDate) === 'object' ? moment(descriptionValues.installationDate).format('YYYY-MM-DD') :  descriptionValues.installationDate.substr(0,10);
    } else {
      if(!this.descriptionForm.valid || !this.parameters.valid || !this.alertParameter.valid || !this.altertNotification.valid || !this.dtmuDevice.valid || (this.frequencyError && this.frequencyError.length > 0 )) {
        if(!this.frequencyError){
          this.toastr.error('Please Enter Valid and Mandatory Values');
          return;
        } else if(this.frequencyError && this.frequencyError.length > 0) {
          this.toastr.error(this.frequencyError);
          return;
        }
      }
    }

    dtmuDeviceValues.remoteController=dtmuDeviceValues.remoteController ? 1 :0;
    dtmuDeviceValues.onoffNotify=dtmuDeviceValues.onoffNotify ? 1 :0;
    console.log('onOffFlag>>>>>>>', dtmuDeviceValues.onOffNotify);

    this.formData.description = {'id':descriptionValues.serialNo, 'makeBy':descriptionValues.makeBy, 'serialNo': descriptionValues.serialNo, 'manufacturingDate': descriptionValues.manufacturingDate, 'installationDate': descriptionValues.installationDate, 'rating': descriptionValues.rating, 'kv':descriptionValues.kv,'deviceId': dtmuDeviceValues.deviceId, 'deviceCategory': dtmuDeviceValues.deviceCategory, 'deviceModel': dtmuDeviceValues.deviceModel,
      'heartBeat': dtmuDeviceValues.heartBeat, 'name': dtmuDeviceValues.name, 'passcode': dtmuDeviceValues.passcode, 'deletedFlag': descriptionValues.deletedFlag, ...metaData, 'last_trigger_time': date, 'remoteController': dtmuDeviceValues.remoteController, 'onOffNotify': dtmuDeviceValues.onOffNotify, 'onOffFlag': dtmuDeviceValues.onOffFlag 
    }

    if(this.action === 'Update') {
      delete this.formData.description.id;
      delete this.formData.description.serialnumber;
    }

    this.formData.parameters = parametersValues;
    this.formData.alertParameter = [{'overLoad':alertParametersValues.overLoad, 'email': alertParametersValues.overLoadEmail, 'sms': alertParametersValues.overLoadSMS, 'frequency': alertParametersValues.overLoadFrequency, 'timeValue': alertParametersValues.overLoadTime},
      {'underLoad': alertParametersValues.underLoad, 'email': alertParametersValues.underLoadEmail, 'sms': alertParametersValues.underLoadSMS, 'frequency': alertParametersValues.underLoadFrequency, 'timeValue': alertParametersValues.underLoadTime},
      {'criticalLoad': alertParametersValues.criticalLoad, 'email': alertParametersValues.criticalLoadEmail, 'sms': alertParametersValues.criticalLoadSMS, 'frequency': alertParametersValues.criticalLoadFrequency, 'timeValue': alertParametersValues.criticalLoadTime},
      {'highVoltage': alertParametersValues.highVoltage, 'email': alertParametersValues.highVoltageEmail, 'sms': alertParametersValues.highVoltageSMS, 'frequency': alertParametersValues.highVoltageFrequency, 'timeValue': alertParametersValues.highVoltageTime},
      {'lowVoltage': alertParametersValues.lowVoltage, 'email': alertParametersValues.lowVoltageEmail, 'sms': alertParametersValues.lowVoltageSMS, 'frequency': alertParametersValues.lowVoltageFrequency, 'timeValue': alertParametersValues.lowVoltageTime},
      {'vUnbalance': alertParametersValues.vUnbalance, 'email': alertParametersValues.vUnbalanceEmail, 'sms': alertParametersValues.vUnbalanceSMS, 'frequency': alertParametersValues.vUnbalanceFrequency, 'timeValue': alertParametersValues.vUnbalanceTime},
      {'iUnbalance': alertParametersValues.iUnbalance, 'email': alertParametersValues.iUnbalanceEmail, 'sms': alertParametersValues.iUnbalanceSMS, 'frequency': alertParametersValues.iUnbalanceFrequency, 'timeValue': alertParametersValues.iUnbalanceTime},
      {'lugTemp': alertParametersValues.lugTemp, 'email': alertParametersValues.lugTempEmail, 'sms': alertParametersValues.lugTempSMS, 'frequency': alertParametersValues.lugTempFrequency, 'timeValue': alertParametersValues.lugTempTime}
    ];

    this.formData.alertNotification = altertNotificationValues;
    console.log('date>>>>>>>', date)
    console.log("FORM DATA>>>>>>>", this.formData);
    if(this.frequencyError && this.frequencyError.length > 0) {
      //return alert(this.frequencyError);
      this.toastr.error(this.frequencyError);
      return;
    }

    console.log("FORM DATA>>>>>", this.formData);

    this.feederService.addUpdateFeeder(this.formData).subscribe((response:any) => {
      console.log("RESPONSE:", response);
      if(response.code==-1){
        this.toastr.error(response.error);
      } else {
        this.toastr.success(response.message);
        this.close(response);
      }
    });

    
  }

}
